import React, { useEffect, useState } from "react";
import Header from "../Header";
import SideBar from "../SideBar";
import axios from "axios";

function ViewCategory() {
  const [category, setCategory] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}bundle/list-category`)
      .then((res) => {
        console.log("category", res.data.category);
        setCategory(res.data.category);
      });
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <SideBar />
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1 className="h2 fw-bold">Category</h1>
            </div>

            <div className="table-sec">
              <div className="table-responsive">
                <table className="table table-borderless table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Category Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {category.map((item, index) => (
                      <tr key={item._id}>
                        <td>{index+1}</td>
                        <td>{item.name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default ViewCategory;
